import React from "react";

function Form() {
  return (
    <>
      <label htmlFor="name">Name</label>
      <input
        type="text"
        name="Name"
        placeholder="Your Name"
        className="px-4 py-2 border-gray-300 border-2 focus:outline-none rounded-md"
      />
      <label htmlFor="email">Email</label>
      <input
        type="email"
        name="email"
        id=""
        placeholder="Your Email "
        className="px-4 py-2 border-gray-300 border-2 focus:outline-none rounded-md"
      />
      <label htmlFor="phone">Phone</label>
      <input
        type="tel"
        placeholder="Your Phone or Whatsapp"
        name="phone"
        id=""
        className="px-4 py-2 border-gray-300 border-2 focus:outline-none rounded-md"
      />
      <label htmlFor="address">Address</label>
      <input
        type="text"
        placeholder="Your address"
        name="address"
        id=""
        className="px-4 py-2 border-gray-300 border-2 focus:outline-none rounded-md"
      />
      <label htmlFor="textarea">Message</label>
      <textarea
        name="message details"
        id=""
        cols=""
        placeholder="Enter Your Message here..."
        rows=""
        className="px-4 py-2 border-gray-300 border-2 focus:outline-none rounded-md"
      ></textarea>

      <input
        type="hidden"
        name="_replyto"
        // value="Your order is success fully flaced we will contact you soon"
      />
      {/* <input type="hidden" name="_captcha" value="false" /> */}
      <input type="hidden" name="_template" value="table"></input>
    </>
  );
}

export default Form;
